import React, { createContext, useContext, useEffect, useState } from 'react';
import { loginAPI, getMeAPI, tokenRefreshAPI } from '../apis/auth/authAPI';
import { getAccessTokenFromCookies, getRefreshTokenFromCookies, removeTokensFromCookies, setTokensInCookies } from '../lib/utils/setTokensInCookies';
import useUserStore from '../store/useUserStore';
import { TAuthContextType, TAuthProviderProps, TMeResponse, TResponseMeData } from '../types/api';
import useAuthStore from 'store/useAuthStore';

const AuthContext = createContext<TAuthContextType | undefined>(undefined);

export default function AuthProvider({ children }: TAuthProviderProps) {
  const { setIsLoggedIn } = useAuthStore(); // Zustand에서 로그인 상태를 가져옴
  const { setUser } = useUserStore();

  const login = async (username: string, password: string): Promise<void> => {
    try {
      const res = await loginAPI({ username, password }); // 로그인 API 호출
      // console.log('Login API Response:', res); // 성공적으로 토큰을 저장하고 있는지 확인
      const accessToken = res.data.accessToken;
      const refreshToken = res.data.refreshToken;

      setTokensInCookies({ accessToken, refreshToken }); // accessToken, refreshToken을 Cookies에 저장 (7일동안 저장하는것을 기본으로 설정해둠)

      // 토큰 저장 후 사용자 정보 가져오기
      const userResponse: TMeResponse = await getMeAPI(); // 사용자 정보 API 호출
      const userData: TResponseMeData = userResponse.data; // zustand에 사용자 데이터 저장
      // console.log('getMeAPI userResponse - userData : ', userData);
      setUser(userData);
      setIsLoggedIn(true);
      //  return userData;
    } catch (error) {
      // 로그인 오류날 경우, 에러모달을 띄움
      // console.error('loginAPI - error: ', error);
      console.error(error);
      throw error;
    }
  };
  // 로그아웃 로직
  const logout = () => {
    setIsLoggedIn(false);
    setUser(null); // Zustand의 사용자 정보 초기화
    removeTokensFromCookies(); // 쿠키에 저장된 accessToken과 refreshToken 삭제
  };

  // 새로고침 시 쿠키에 저장된 토큰으로 로그인 상태 확인
  const checkLoginStatus = async () => {
    const accessToken = getAccessTokenFromCookies();
    // console.log('===========refreshToken', Boolean(accessToken), accessToken, refreshToken);

    if (accessToken) {
      try {
        // 엑세스 토큰을 이용해 사용자 정보 가져오기
        const userResponse: TMeResponse = await getMeAPI();
        const userData: TResponseMeData = userResponse.data;
        setUser(userData);
        setIsLoggedIn(true);
      } catch (error) {
        // console.error('엑세스 토큰 만료 또는 오류: ', error);

        // 리프레시 토큰이 있다면 엑세스 토큰 갱신 시도
        await tokenRefresh();
      }
    } else {
      logout(); // 토큰이 없다면 로그아웃 상태로 처리
    }
  };

  const tokenRefresh = async () => {
    const refreshToken = getRefreshTokenFromCookies();
    if (refreshToken) {
      try {
        const data = { refreshToken };
        const refreshResponse = await tokenRefreshAPI(data); // 리프레시 토큰을 사용해 새로운 엑세스 토큰 발급
        // console.log('새로고침해서 응답반음 refreshResponse', refreshResponse);
        const newAccessToken = refreshResponse.data.accessToken;
        setTokensInCookies({ accessToken: newAccessToken, refreshToken });
        // await checkLoginStatus(); // 갱신 후 다시 체크
        //
        // const userResponse: TMeResponse = await getMeAPI();
        // const userData: TResponseMeData = userResponse.data;
        // setUser(userData);
        // setIsLoggedIn(true);
      } catch (refreshError) {
        alert('로그인 정보가 만료되었습니다. 로그아웃 처리 됩니다.');
        // console.error('리프레시 토큰 오류: ', refreshError);
        logout(); // 리프레시 토큰도 유효하지 않다면 로그아웃 처리
      }
    } else {
      logout(); // refreshToken도 없다면 로그아�� 처리
      // console.error('refreshToken is null');
    }
  };

  // useEffect(() => {
  //   // 페이지가 로드될 때 로컬 스토리지에서 로그인 상태를 확인
  //   console.log('Login API isLoggedIn:', isLoggedIn);
  // }, [isLoggedIn]);

  // useEffect(() => {
  //   // 페이지가 로드되거나 새로고침 시 로그인 상태 확인
  //   // console.log('새로고침?? : ', isLoggedIn);
  //   checkLoginStatus();
  // }, []); // 의존성 배열에 빈 값을 두어 첫 로드 시 한 번만 실행

  return <AuthContext.Provider value={{ login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = (): TAuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
